import { createStore } from "vuex";
import auth from "./modules/auth";
import ui from "./modules/ui";
import cards from "./modules/cards";

const store = createStore({
  modules: {
    auth,
    ui,
    cards,
  },
});

export default store;
